import CourseCreationModal from './CourseCreationModal';

export default CourseCreationModal;
